/** */
class MEnvironment {

    /** */
    public static get environmentName(): string | undefined {
        return process.env.REACT_APP_ENVIRONMENT?.toLowerCase();
    }

    /** */
    public static get isLocal(): boolean {
        return MEnvironment.environmentName === 'local';
    }

    /** */
    public static get isDevelopment() {
        return MEnvironment.environmentName === 'azdev';
    }

    /** */
    public static get isTest() {
        return MEnvironment.environmentName === 'aztest';
    }

    /** */
    public static get isProduction() {
        return MEnvironment.environmentName === 'azprod';
    }

}

export default MEnvironment;
